<template>
  <div class="modalview">
    <div
      class="modal fade"
      data-bs-backdrop="static"
      id="tr_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="Trends Report Modal Popup"
      aria-hidden="true"
    >
      <div
        class="close-modal"
        data-dismiss="modal"
        v-on:click="closeMe()"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </div>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body faded-content">
            <h3 class="modal-title" id="exampleModalLabel">
              {{ reporttitle }}
            </h3>
            <p v-html="limitText(content.indicator_type.body, 0, 350)" />
          </div>
          <div class="modal-body-more">
            <a :href="reporturl" class="button">Keep Reading</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';
  export default {
    props: {
      content: {
        type: Object,
        required: true,
      },
      imagespath: {
        type: String,
        required: true,
      },
      reporturl: {
        type: String,
        required: false,
      },
      reporttitle: {
        type: String,
        required: false,
      },
    },

    mounted() {
      this.$nextTick(() => {
        $('#tr_modal').modal('show');
      });
      $('#tr_modal').modal('show');
    },
    data: function () {
      return {
        images_path: this.imagespath,
      };
    },
    computed: {},
    methods: {
      limitText: function (value, length_start, length_value) {
        //return value;
        if (value !== null || value != '') {
          var string = value;
          var length = length_value;
          return string.substring(length_start, length) + '...';
        }
      },
      getKey: function (object_path) {
        var keyExists = _.get(this.content, object_path, 0);

        if (keyExists !== 0) {
          return true;
        }
        return false;
      },
      closeMe() {
        $('#tr_modal').modal('hide');
        this.$emit('modal-closed');
      },
    },
  };
  //https://stackoverflow.com/questions/13869627/unable-to-access-json-property-with-dash  jsonObj.profile - id
  //To access a key that contains characters that cannot appear in an identifier, use brackets: jsonObj["profile-id"]
</script>
<style lang="scss" scoped>
  #tr_modal {
    background-color: rgba(0, 0, 0, 0.5);
  }
</style>
